import type { SVGProps } from "react";

export function KimiLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      {/* Crescent moon — Moonshot / Kimi */}
      <path d="M15.5 3a9 9 0 1 0 5.5 16.1A7.5 7.5 0 0 1 15.5 3z" />
    </svg>
  );
}
